<div class="main">
    <ngx-spinner bdColor="rgba(51,51,51,0.55)"
                 size="medium"
                 color="#fff"
                 type="line-spin-clockwise-fade"
                 [fullScreen]="false">
        <p class="loading">{{ 'general.loading' | translate }}...</p>
    </ngx-spinner>
    <div class="row ml-0">
        <div class="col-12">
            <h2 class="page-title" tabindex="0">{{'user.users' | translate}}</h2>
        </div>
    </div>
    <div class="row ml-0">
        <div class="col-12">
            <xng-breadcrumb separator=" > ">
                <ng-container *xngBreadcrumbItem="let breadcrumb">
                    <span *ngIf="breadcrumb">
                        {{ 'breadcrumb.' + breadcrumb | translate }}
                    </span>
                </ng-container>
            </xng-breadcrumb>
        </div>
        <div class="col-12 text-right" *ngxPermissionsExcept="['Activate', 'Expired', 'Supervisor', 'SecurityAgent']">
            <button id="add_bulk_user" type="button" (click)="bulkImportBtnClick()" title="{{'user.user_bulk_import' | translate}}"
                    class="btn btn-red btn-h-red btn-group mr-2">
                <span class="text-center w-100">{{'user.user_bulk_import' | translate}}</span>
            </button>
            <button id="add_user" type="button" title="{{'user.add_user' | translate}}" routerLink = "add-user" routerLinkActive="active"
                    class="btn btn-green btn-h-green btn-group">
                <span class="text-center w-100">{{'user.add_user' | translate}}</span>
            </button>
        </div>
    </div>
    <div class="row ml-0">
        <div class="col-12">
            <div class="d-flex flex-row bd-highlight float-right">
                <!-- Active/Inactive filter -->
                <div class="p-2 bd-highlight">
                    <span>{{'status' | translate}}</span><br>
                    <div ngbDropdown class="d-inline-block w-100">
                        <button class="btn btn-outline-secondary mr-1 bg-white w-100 text-dark"
                            title="{{ 'general.'+statusFilter.toLowerCase() | translate }}" id="status" ngbDropdownToggle>
                            {{ 'general.'+statusFilter.toLowerCase() | translate }} <i class="fa fa-caret-down" aria-hidden="true"></i>
                        </button>
                        <div ngbDropdownMenu aria-labelledby="status">
                            <button ngbDropdownItem (click)="changeStatusFilterLabel(status)" 
                                title="{{ 'general.'+status.toLowerCase() | translate }}" *ngFor="let status of statuses">
                                {{ 'general.'+status.toLowerCase() | translate }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="p-2 bd-highlight">
                    <label class="mb-0" for="role">{{'roles.role' | translate}}</label><br>
                    <!--Role filter-->
                    <div ngbDropdown class="d-inline-block w-100">
                        <button class="btn btn-outline-secondary mr-1 bg-white w-100 text-dark"
                                title="{{ 'roles.'+roleFilter | translate }}" id="role" ngbDropdownToggle>
                            {{ 'roles.'+roleFilter | translate }} <i class="fa fa-caret-down" aria-hidden="true"></i>
                        </button>
                        <div ngbDropdownMenu>
                            <button ngbDropdownItem (click)="changeRoleLabel(role.name)"
                                    title="{{ 'roles.'+role.name | translate }}" *ngFor="let role of roles">
                                {{ role.name | translate }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="p-2 bd-highlight">
                    <label for="filter" class="mb-0">{{'general.filter_user_table' | translate}}</label>
                    <input type="text" id="filter" class="form-control rounded border-secondary" (keyup)="emptyInput()" maxlength="50">
                </div>
                <div class="mt-2 bd-highlight button-group">
                    <button class="btn remove-filter-btn ml-1" title="" (click)="clearFilter()">
                        <i class="fa fa-times fa-sm" title="{{ 'general.clear_filter' | translate }}"></i>
                    </button>
                    <button class="btn apply-filter-btn ml-1" title="" (click)="applyFilter()">
                        <i class="fa fa-filter fa-xs" title="{{ 'general.apply_filter' | translate }}"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="row ml-0">
        <div class="col-12">
            <table class="border-top" mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" matSortActive="profileFirstName" matSortDirection="asc" matSortDisableClear [attr.role]="null">
                <!-- Name Column -->
                <ng-container matColumnDef="profileFirstName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> {{'general.name' | translate}} </th>
                    <td class="text-break" mat-cell *matCellDef="let user" [attr.role]="null"> {{user.profileFirstName}} {{user.profileLastName}} </td>
                </ng-container>
                <!-- Email Column -->
                <ng-container matColumnDef="email">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> {{'general.email' | translate}} </th>
                    <td class="text-break" mat-cell *matCellDef="let user" [attr.role]="null"> {{user.email}} </td>
                </ng-container>
                <!-- Phone Number Column -->
                <ng-container matColumnDef="profilePhoneNumber">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> {{'general.phone_number' | translate}} </th>
                    <td class="text-break" mat-cell *matCellDef="let user" [attr.role]="null"> {{user.profilePhoneNumber}} </td>
                </ng-container>
                <!-- Role Column -->
                <ng-container matColumnDef="role">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> {{'general.role' | translate}} </th>
                    <td mat-cell *matCellDef="let user" [attr.role]="null"> {{'roles.'+user.role | translate}} </td>
                </ng-container>
                <!-- Active Column -->
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header [attr.role]="null" scope="col"> {{'status' | translate}} </th>
                    <td mat-cell *matCellDef="let user" [attr.role]="null" scope="row"> 
                        <i *ngIf="user.active==0 || user.active>3 && user.active<6" class="fa fa-circle text-danger red-text" title="{{'general.inactive' | translate}}"><span class="info-act-inact">&nbsp;{{'general.inactive' | translate}}</span></i>
                        <i *ngIf="user.active>0 && user.active<4" class="fa fa-circle green-text" title="{{'general.active' | translate}}"><span class="info-act-inact">&nbsp;{{'general.active' | translate}}</span></i>
                        <i *ngIf="user.active>5" class="fa fa-circle gray-text" title="{{'general.deleted' | translate}}"><span class="info-act-inact">&nbsp;{{'general.deleted' | translate}}</span></i>
                    </td>
                </ng-container>
                <!-- Actions Column -->
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef scope="col" [attr.role]="null" scope="col"> {{'general.actions' | translate}} </th>
                    <td mat-cell *matCellDef="let user" [attr.role]="null">
                        <div class="dropdown dropdown-menu-left" ngbDropdown >
                            <button ngbDropdownToggle class="btn btn-default cursor" tabindex="0" title=""><i class="fa fa-ellipsis-v" title="{{'user.user_actions' | translate}} {{user.profileFirstName}} {{user.profileLastName}}"></i></button>
                            <div ngbDropdownMenu class="dropdown-menu dropdown-menu-left">
                                <button ngbDropdownItem [routerLink]="['view-user', user.id]" routerLinkActive="active" title="{{'general.view' | translate}}"><i class="fa fa-eye"></i> {{'general.view' | translate}}</button>
                                <button ngbDropdownItem [routerLink]="['edit-user', user.id]" routerLinkActive="active" *ngxPermissionsExcept="['Activate', 'Expired', 'Supervisor', 'SecurityAgent']" title="{{'general.edit' | translate}}"><i class="fa fa-pencil"></i> {{'general.edit' | translate}}</button>
                                <button ngbDropdownItem (click)="changeUserStatus(user)" *ngxPermissionsExcept="['Activate', 'Expired', 'Supervisor', 'SecurityAgent']" title="{{ ((user.active > 0 && user.active < 4) ?'general.inactivate': (user.active > 3 && user.active < 6) ?'general.activate': 'general.restore') | translate }}">+/- {{((user.active > 0 && user.active < 4)?'general.inactivate': (user.active > 3 && user.active < 6) ?'general.activate': 'general.restore') | translate }}</button>
                                <button ngbDropdownItem [routerLink]="['edit-user-picture', user.id, user.photo]" routerLinkActive="active" *ngxPermissionsExcept="['Activate', 'Expired', 'Supervisor', 'SecurityAgent']" title="{{'profile.edit_picture' | translate}}"><i class="fa fa-user"></i> {{'profile.edit_picture' | translate}}</button>
                                <button ngbDropdownItem (click)="viewGroups(user)" title="{{'setting.groups' | translate}}"><i class="fa fa-group"></i>{{'setting.groups' | translate}}</button>
                                <button ngbDropdownItem [routerLink]="['/main/users/manageDocuments', user.id]" routerLinkActive="active" title="{{'general.documents' | translate}}"><i class="fa fa-file-alt"></i> {{'general.documents' | translate}}</button>
                                <span *ngIf="user.active==2">
                                    <button ngbDropdownItem (click)="resendPasswordPrompt(user)" *ngxPermissionsExcept="['Activate', 'Expired', 'Supervisor', 'SecurityAgent']" title="{{'user.resend_invitation' | translate}}"><i class="fa fa-repeat"></i> {{'user.resend_invitation' | translate}}</button>
                                </span>
                                <span *ngIf="user.active==1 || user.active==3">
                                    <button ngbDropdownItem (click)="resetPasswordPrompt(user)" *ngxPermissionsExcept="['Activate', 'Expired', 'Supervisor', 'SecurityAgent']" title="{{'password.reset_pass' | translate}}"><i class="fa fa-repeat"></i> {{'password.reset_pass' | translate}}</button>
                                </span>
                                <button ngbDropdownItem (click)="deleteUser(user)" *ngxPermissionsExcept="['Activate', 'Supervisor', 'SecurityAgent']" title="{{'general.delete' | translate}}"><i class="fa fa-trash"></i> {{'general.delete' | translate}}</button>
                            </div>
                        </div>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator #paginator [pageIndex]="pageIndex" [length]="totalLength" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons (page)="nextPage($event)"></mat-paginator>
        </div>
    </div>
</div>